import {useEffect} from "react";
import {useTitle} from "../../contexts/title";

export default function BadRequestPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Bad Request')
	}, [pageTitle]);

	return (<>
		<div className={'content-block'}>
			<h2>Bad Request</h2>
		</div>
	</>)
}
